'use string'

import {createElements, findSelectionAndCrmData, numberWithCommas} from "../../functions";
import {CardTypes} from "../../common";
import {renderUpdateValuesOnDemand} from "../../app";
import {addApplyNow, setWidthOfCardDependingOnMenu} from "./optionsCards";
import {isMobile, settingsData} from "../../settings";
import {addInfopointsBlock, createHeader} from "./cardsFunctions";
import {dataArrayOfFlat, facingDictionary} from "./cardsConfig";
import {addConferenceBuyNow} from "../apply-now/buyNow";
import {changeLangToCurrent} from "../language/langSwitcher";
import {zoom} from "../../libs/directive";
import {rollUpAndExpandCompareCards} from "./cardsAnimation";

export const createCompareBlock = () => {
    const block = createElements('div', ['compare-block', 'non-canvas'], document.body);

    setTimeout(() => renderUpdateValuesOnDemand(true), 1000);
    setWidthOfCardDependingOnMenu(block)
    createCards(block);

    let drag = false;
    block.addEventListener(
        settingsData.isDesktopMode && settingsData.isTouchEvent ? 'touchstart' : 'mousedown', () => drag = false);

    block.addEventListener(
        settingsData.isDesktopMode && settingsData.isTouchEvent ? 'touchmove' : 'mousemove', () => drag = true);

    block.addEventListener(
        settingsData.isDesktopMode && settingsData.isTouchEvent ? 'touchend' : 'mouseup', (e) => {
            // console.log(drag ? 'drag' : 'click')
            !drag && rollUpAndExpandCompareCards(e)
        });

    // block.addEventListener('click', rollUpAndExpandCompareCards);
}

const createCards = (parent) => {
    const cardsList = document.querySelectorAll(`.${CardTypes.Unit}-card`);

    cardsList.forEach(card => {
        const engineId = card.getAttribute('data-engineid');
        const {crmDataOfFlat} = findSelectionAndCrmData(engineId);

        const cardBlock = createElements('div', ['compare-block__card', 'compare-card'], parent, 'beforeEnd', {
            data: 'data-engineid',
            value: engineId,
        });


        create2dPlans(crmDataOfFlat, cardBlock);

        const wrapper = createElements('div', [`compare-card__wrapper`], cardBlock);
        createHeader(crmDataOfFlat, wrapper, config, 'compare', false, 'beforeEnd');
        addPriceToCompareCards(crmDataOfFlat, wrapper, 'compare');
    })


    createCloseButton(parent);
}

const create2dPlans = (crmDataOfFlat, parent) => {

    const planBlock = createElements('div', ['compare-block__2dPlan-block', 'zoom'], parent);
    const plan =  createElements('img', ['compare-block__2dPlan'], planBlock, 'beforeEnd', {
        data: 'src',
        value:  isMobile
            ? crmDataOfFlat.assets.plan2DVertical
            : crmDataOfFlat.assets.plan2D || "img/holder.jpg",
    });

    zoom();
}

const addPriceToCompareCards = (crmDataOfFlat, cardBox, card) => {
    const showPrice = config.crmProjectSettings.property.settings.displayPrice !== 'hide' || settingsData.isConferenceHost;

    if (crmDataOfFlat.status === "Available" && crmDataOfFlat.salePrice !== 0 && showPrice) {
        const priceValue = cardBox.querySelector(`.${card}-card__price-value`);
        const price = numberWithCommas(Math.floor(crmDataOfFlat.salePrice));
        priceValue.innerHTML = price;
    }
}


const createCloseButton = (parent) => {
    const closeButton = createElements('div', ['compare-card__close-btn', `icon-close`], parent);
    closeButton.addEventListener('click', () => document.querySelector('.compare-block').remove())
}
